// src/components/Header.jsx
import React from 'react';
import { Link } from 'react-router-dom';

import './HeaderFooter.css';

const Header = () => {
  return (
    <header className="header">
      <div className="page-content">
        <div className="logo-container">
          {/* Ajuste o src/alt conforme seu logo */}
          <Link to="/">
            <img src="/images/logo-codi.png" alt="Plataforma CODI" id="logo" />
          </Link>
          <Link to="/">
            <img src="/images/logo-codi-alt.png" alt="Plataforma CODI" id="logo-alt" />
          </Link>
        </div>

        <nav id="menu">
          {/*
          <div className="menu-item">
            <Link to="/">Início</Link>
          </div>
          */}
          <div className="menu-item">
            <Link to="/funil">Funil da Permanência</Link>
          </div>
          <div className="menu-item">
            <Link to="/financeiro">Otimização Financeira</Link>
          </div>
          <div className="menu-item">
            <Link to="/enade">ENADE</Link>
          </div>
          <div className="menu-item">
            <Link to="/contato">Contato</Link>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
